import(/* webpackMode: "eager" */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/app/blogs/[slug]/loading.tsx");
